import { DocumentUpload, SearchNormal1, TickSquare } from "iconsax-react";
import { FreeTrialServiceStepProps } from "../../types/free-trial/steps/type";

export const VISUAL_CLOTHES_SERVICE_STEPS: FreeTrialServiceStepProps[] = [
  { id: "upload-pic", label: "Upload Image", svg: <DocumentUpload variant="Broken" /> },
  { id: "processing", label: "Processing", svg: <SearchNormal1 variant="Broken" /> },
  { id: "result", label: "Result", svg: <TickSquare variant="Broken" /> },
];
